export default "__VITE_ASSET__c19313d6__"